import './SpinnerInput.less';
import React from 'react';
import Icon from '../../components/icon/Icon';
import {addMouseWheelListener, removeMouseWheelListener} from '../../dom/event-handlers/on-mouse-wheel';

export default class SpinnerInput extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            value: props.defaultValue
        };

    }

    static getDerivedStateFromProps(props, state) {

        if (props.value !== undefined) {
            state.value = props.value;

            return state;
        }

        if (props.imperativeValue !== state.prevImperativeValue) {
            state.prevImperativeValue = props.imperativeValue;

            state.value = props.imperativeValue;

            return state;
        }

        return null;
    }

    componentDidMount() {
        this.setOnMouseWheel();
    }

    componentWillUnmount() {
        this.releaseOnMouseWheel();
    }

    componentDidUpdate() {
        if (!this.ensureValueIsValid()) {
            return;
        }
    }

    getOptions = () => {
        return this.props.options;
    };

    /**
     *
     * check if value is in options or not
     * if not, set value to default value
     */
    ensureValueIsValid = () => {
        const {defaultValue} = this.props;
        const {value} = this.state;

        if (value === null) {
            return true;
        }

        if (this.getOptions().find(option => option.value === value)) {
            return true;
        }

        this.updateValue(defaultValue);

        return false;
    };

    getShouldDrawnOptions = () => {
        const {radius, isClosedCircle} = this.props;
        const {value} = this.state;

        const options = this.getOptions();

        const result = [];

        for (let i = 0; i < options.length; i++) {
            if (value !== null && options[i].value !== value) {
                continue;
            }

            for (let j = i - radius
                ; j <= i + radius
                ; j++
            ) {
                if (j < 0) {
                    if (!isClosedCircle) {
                        result.push(j);
                        continue;
                    }

                    const index = (j + 1) % options.length + options.length - 1;

                    result.push(options[index]);
                    continue;
                }

                if (j > options.length - 1) {
                    if (!isClosedCircle) {
                        result.push(j);
                        continue;
                    }
                    //24 - 1 - (24 - 1) % 24 = 23 - 23 = 0
                    //24 - 1 - (25 - 1) % 24 = 23 - 0 = 23
                    // const index = options.length - 1 - (j - 1) % options.length;
                    const index = j - options.length;

                    result.push(options[index]);
                    continue;
                }

                result.push(options[j]);
            }

            break;
        }

        if (result.length > 0) {
            return result;
        }

        return options.slice(0, radius);
    };

    getOptionStyle = (centralPosition) => {
        const {radius, align} = this.props;

        const centralDistance = Math.abs(centralPosition);


        const K = (radius - centralDistance) / radius;
        const H = centralPosition / radius;
        const L = centralDistance / radius;

        const dir = align === 'center' ? 0 : (align === 'left' ? -1 : 1);

        const rotateX = `rotateX(${L * L * 50}deg)`;
        const skewX = `skewX(${dir * H * L * 8}deg)`;
        const translateX = `translateX(${dir * L * L * 0.2}em)`;

        return {
            fontSize: 1 + 0.3 * K + 'em',
            lineHeight: 0.7 + 0.9 * K + 'em',
            opacity: 0.6 + 0.4 * K,
            transform: `${rotateX} ${skewX} ${translateX}`
        };
    };

    renderOptionItem = (option, index) => {
        const {radius, align} = this.props;
        const {value} = this.state;

        const centralPosition = index - radius;

        const isCenter = centralPosition === 0;

        const style = this.getOptionStyle(centralPosition);

        if ('number' === typeof option) {
            return <li
                className={(isCenter ? ' center' : '')}
                key={option}
            >
                <div style={style}>
                    &nbsp;
                </div>
            </li>;
        }

        return <li
            key={`${option.value} - ${index}`}
            className={(value === option.value ? ' selected' : '') + (isCenter ? ' center' : '')}
        >
            <div style={style}>
                {option.label}
            </div>
        </li>;
    };

    renderOptionsListView = () => {
        return <ul>
            {
                this.getShouldDrawnOptions().map(this.renderOptionItem)
            }
        </ul>;
    };

    updateValue = (value) => {
        const {onChange} = this.props;
        this.setState(
            {value},
            () => {
                onChange(this.state.value);
            }
        );
    };

    selectAbove = () => {
        const {isClosedCircle} = this.props;

        const options = this.getOptions();

        const index = this.getSelectedOptionIndex();

        if (index === null) {
            this.updateValue(options[0].value);
            return;
        }

        if (index > 0) {
            this.updateValue(options[index - 1].value);
            return;
        }

        if (isClosedCircle) {
            this.updateValue(options[options.length - 1].value);
        }
    };

    selectBelow = () => {
        const {isClosedCircle} = this.props;

        const options = this.getOptions();

        const index = this.getSelectedOptionIndex();

        if (index === null) {
            this.updateValue(options[0].value);
            return;
        }

        if (index < options.length - 1) {
            this.updateValue(options[index + 1].value);
            return;
        }

        if (isClosedCircle) {
            this.updateValue(options[0].value);
        }
    };

    getSelectedOptionIndex = () => {
        const {value} = this.state;
        const options = this.getOptions();

        for (let i = 0; i < options.length; i++) {
            if (options[i].value === value) {
                return i;
            }
        }

        return null;
    };

    continuationTrigger = null;
    continuation = null;

    startContinuation = (act) => {
        const options = this.getOptions();

        act();

        this.continuationTrigger = setTimeout(() => {
            const delay = Math.min(150, Math.max(50, 5000 / options.length));
            this.continuation = setInterval(act, delay);
        }, 300);
    };

    stopContinuation = () => {
        clearTimeout(this.continuationTrigger);
        clearInterval(this.continuation);
    };

    setOnMouseWheel = () => {
        this.mouseWheelCallback = addMouseWheelListener((ev, data) => {
            if (this.body === null || !(ev.target === this.body || this.body.contains(ev.target))) {
                return;
            }

            if (data.direction === 1) {
                this.selectBelow();
            } else if (data.direction === -1) {
                this.selectAbove();
            }

            if (document.activeElement) {
                document.activeElement.blur();
            }
        });
    };

    releaseOnMouseWheel = () => {
        removeMouseWheelListener(this.mouseWheelCallback);
    };

    getIsAboveActive = () => {
        const {isClosedCircle} = this.props;

        if (isClosedCircle) {
            return true;
        }

        return this.getSelectedOptionIndex() > 0;
    };

    getIsBelowActive = () => {
        const {options, isClosedCircle} = this.props;

        if (isClosedCircle) {
            return true;
        }

        return this.getSelectedOptionIndex() < options.length - 1;
    };

    render() {
        const {value} = this.state;
        const {align} = this.props;

        return <div className={`spinner-input align-${align}` + (value === null ? ' is-empty' : '')}>
            <div
                className={'head' + (this.getIsBelowActive() ? ' active' : '')}
                onMouseDown={() => this.startContinuation(this.selectBelow)}
                onMouseUp={() => this.stopContinuation()}
                onMouseLeave={() => this.stopContinuation()}
            >
                <Icon name="angle-up"/>
            </div>
            <div
                className="body"
                ref={el => this.body = el}
            >
                {this.renderOptionsListView()}
            </div>
            <div
                className={'foot' + (this.getIsAboveActive() ? ' active' : '')}
                onMouseDown={() => this.startContinuation(this.selectAbove)}
                onMouseUp={() => this.stopContinuation()}
                onMouseLeave={() => this.stopContinuation()}
            >
                <Icon name="angle-down"/>
            </div>
        </div>;
    }
}


SpinnerInput.defaultProps = {
    defaultValue: null,
    value: undefined, // force update value if !== undefined
    radius: 2, // number of options shown on below or upper of selected option
    isClosedCircle: true,
    align: 'center',
    options: new Array(60).fill(null).map(
        (_, index) => ({value: index, label: index < 10 ? '0' + index : '' + index})
    ),
    onChange: (value) => console.log('(SpinnerInput) onChange is omitted', value),
};
